import { render, staticRenderFns } from "./AnnounceTextColor.vue?vue&type=template&id=29d79b2d&"
import script from "./AnnounceTextColor.vue?vue&type=script&lang=js&"
export * from "./AnnounceTextColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports